import { Layout, theme } from "antd";
import React from "react";

const { Header, Content } = Layout;


export interface SubPageLayoutProps {
  header: React.JSX.Element;
  children?: React.ReactNode;
}

export const SubPageLayout: React.FC<SubPageLayoutProps> = (props) => {

  const {
    token: { colorText },
  } = theme.useToken();
  return (
    <Layout>
      <Header style={{ padding: 0, height: "fit-content", color: colorText, backgroundColor: "transparent" }}>{props?.header}</Header>
      <Content
        style={{
          paddingTop: props?.header?.props?.description ? '75px': '',
          display: "flex",
          flexDirection: "column",
        }}
      >
        {props.children}
      </Content>
    </Layout>
  );
};
